import React from "react";
import Home from "../pages/home/Home";
import { Outlet, Route, Routes } from "react-router-dom";
import Login from "../pages/auth/login/Login";
import SignUp from "../pages/auth/signup/SignUp";
import Otp from "../pages/auth/otp/Otp";
import Forgot from "../pages/auth/forgot/Forgot";
import ResetPassword from "../pages/auth/resetpassword/ResetPassword";
import CreateProfile from "../pages/auth/createprofile/CreateProfile";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";
import ProfileDetails from "../pages/profiledetails/ProfileDetails";
import AboutUs from "../pages/aboutus/AboutUs";
import Knowledge from "../pages/knowledgecenter/Knowledge";
import BlogDetails from "../pages/knowledgecenter/BlogDetails";
import Pcos from "../pages/health/pcos/Pcos";
import DoctorInternal from "../pages/doctor/DoctorInternal";
import DoctorDetails from "../pages/doctor/DoctorDetails";
import Endometriosis from "../pages/health/endometriosis/Pcos";
import Menopause from "../pages/health/menopause";
import Postpartum from "../pages/health/postpartum";
import HealthPlan from "../pages/healthplan/HealthPlan";
import Subscription from "../pages/subscription/Subscription";
import Transaction from "../pages/transaction/Transaction";
import Success from "../pages/healthplan/afterPaymentPage/Success";
import Fail from "../pages/healthplan/afterPaymentPage/Fail";
import Policy from "../pages/terms&policy/Policy";
import Terms from "../pages/terms&policy/Terms";
import { PageNotFound } from "../pages/404notFound/PageNotFound";

const Routing = () => {



  const WithHeader = () => {
    return (
      <>
        <Header />
        <Outlet />
        <Footer />
      </>
    );
  };


  return (
    <Routes>
      {/* Auth Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/otp" element={<Otp />} />
      <Route path="/forgot" element={<Forgot />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/create-profile" element={<CreateProfile />} />
      <Route path="/payment-success" element={<Success />} />
      <Route path="/payment-fail" element={<Fail />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/policy" element={<Policy />} />


      {/* Common Routes */}

      <Route path="/" element={<WithHeader />}>
        <Route path="/" element={<Home />} />
        <Route path="/profile-details" element={<ProfileDetails />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/pcos-symptoms-causes-treatment" element={<Pcos />} />
        {/* <Route path="/knowledge-center" element={<Knowledge />} /> */}
        <Route path="/blog-details" element={<BlogDetails />} />
        <Route path="/doctors/:category?" element={<DoctorInternal />} />
        <Route path="/doctors-details/:doctorId" element={<DoctorDetails />} />
        <Route path="/endometriosis-symptoms-causes-treatment" element={<Endometriosis />} />
        <Route path="/menopause-symptoms-causes-treatment" element={<Menopause />} />
        <Route path="/postpartum-symptoms-causes-treatment" element={<Postpartum />} />
        <Route path="/healthplan" element={<HealthPlan />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/transaction" element={<Transaction />} />
      <Route path="/*" element={<PageNotFound />} />

      </Route>
    </Routes>
  );
};

export default Routing;
